import { render, staticRenderFns } from "./WordToPdf.vue?vue&type=template&id=3c2f87dc&scoped=true"
import script from "./WordToPdf.vue?vue&type=script&lang=js"
export * from "./WordToPdf.vue?vue&type=script&lang=js"
import style0 from "./WordToPdf.vue?vue&type=style&index=0&id=3c2f87dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f87dc",
  null
  
)

export default component.exports